import { render, staticRenderFns } from "./client-quotation-details.vue?vue&type=template&id=5508200e&scoped=true"
import script from "./client-quotation-details.vue?vue&type=script&lang=js"
export * from "./client-quotation-details.vue?vue&type=script&lang=js"
import style0 from "./client-quotation-details.vue?vue&type=style&index=0&id=5508200e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5508200e",
  null
  
)

export default component.exports